import { ComponentStyleConfig } from '@chakra-ui/react';

export const Tabs: ComponentStyleConfig = {
  baseStyle: {
    tab: {
      letterSpacing: '0.96px',
      lineHeight: 1.4,
      opacity: 0.72,
      transition: 'opacity 0.2s',
      _selected: {
        fontWeight: 500,
        opacity: 1,
      },
      ':hover:not(:disabled)': {
        opacity: 1,
      },
      _focus: {
        boxShadow: 'none',
      },
      _disabled: {
        cursor: 'default',
        opacity: 0.4,
      },
    },
    tablist: {
      h: 10,
      '& .chakra-tabs__tab:not(:first-of-type)': {
        ml: 4,
      },
    },
  },
  variants: {
    'soft-rounded': {
      tab: {
        color: 'M.70',
        bg: 'M.30',
        borderRadius: 4,
        lineHeight: 1.4,
        fontWeight: 500,
        py: 1.5,
        px: 3,
        height: '33px',
        textTransform: 'none',
        letterSpacing: 0,
        _selected: {
          color: 'M.10',
          bg: 'M.70',
        },
      },
      tabpanel: {
        p: 0,
      },
      tablist: {
        '& .chakra-tabs__tab:not(:first-of-type)': {
          ml: 3,
        },
      },
    },
    unstyled: {
      tablist: {
        h: 8,
      },
      tab: {
        h: 8,
        color: 'M.70',
        px: 0,
        pt: 2,
        pb: 3.5,
        zIndex: 1,
        _selected: {
          pb: 3,
          borderBottom: '2px solid',
          borderColor: 'M.70',
        },
      },
    },
  },
  defaultProps: {
    variant: 'unstyled',
    size: 'sm',
  },
};
